<template>
  <div style="height: 100%">

    <b-dropdown size="sm" split text="AC Test" right variant="dark" class="m-2" v-if="is_editable">
      <!-- <b-dropdown-item :href="`/mainDashboardSiteDetail/`" target="_blank">
        <div class="icon-map-marker-cs"></div>
        <span>Dashboard</span>
      </b-dropdown-item>
      -->
      <!-- <b-dropdown-item @click="modal_show('modal-ac-test-generate-entry')" v-if="this.acData.length == 0"> -->
      <b-dropdown-item @click="modal_show('modal-ac-test-generate-entry')">
        <div class="icon-pencil-cs"></div>
        <span>Create n entry</span>
      </b-dropdown-item>
      <b-dropdown-item @click="modal_show('modal-ac-test-update-entry')">
        <div class="icon-pencil-cs"></div>
        <span>Update Selected entry</span>
      </b-dropdown-item>
    </b-dropdown>

    <!-- :gridOptions="gridOptions" @selection-changed="onSelectionChanged" -->
    <ag-grid-vue style="width: 100%; height: 600px;" class="flex-grow-1 flex-shrink-1 ag-theme-alpine"
      :suppressRowClickSelection="true" :defaultColDef="defaultColDef" :columnDefs="columnDefs" rowSelection="multiple"
      :rowData="rowData" @grid-ready="onGridReady"></ag-grid-vue>

    <!-- Modal loading / in progress -->
    <!-- <b-modal ref="modal-loading-in-progress" size="lg" centered hide-footer hide-header title="" :no-close-on-backdrop="true"> -->
    <b-modal ref="modal-loading-in-progress" size="lg" centered hide-footer hide-header title="">
      <div class="d-block">
        <!-- date | time | project name | site name -->
        <b-row class="mb-3">
          <b-col>
            <div class="text-center text-muted mb-4">
              <h1 class="text-white"><b>Loading in progress</b></h1>
            </div>
            <div class="text-center">
              <div style="color: #ffffff;">
                <!-- <span class="fa fa-spinner fa-spin fa-3x"></span> -->
                <span class="icon-spinner-cs"></span>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>


    <!-- modal generate n ac test -->
    <b-modal ref="modal-ac-test-generate-entry" size="lg" centered hide-footer hide-header title="">
      <div class="d-block">
        <b-row class="modal-row-header">
          <b-col>
            <div class="text-white h3"># of AC Test entry</div>
          </b-col>
        </b-row>
        <!-- desc observation -->
        <b-row>
          <b-col>
            <b-form-input type="number" step="1" min="1" placeholder="No of entries to be created." v-model="oModel.acTest_new"></b-form-input>
          </b-col>
        </b-row>
        <b-row style="padding-top: 20px;" v-if="is_editable">
          <b-col class="text-right">
            <base-button @click="modal_close('modal-ac-test-generate-entry')" type="danger" outline>Cancel</base-button>
            <base-button @click="batch_process_add_ac_test_entry()" type="primary">Save</base-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <!-- modal update ac test -->
    <b-modal ref="modal-ac-test-update-entry" size="xl" centered hide-footer hide-header title="">
      <div class="d-block">
        <b-row class="modal-row-header">
          <b-col>
            <div class="text-white h3">Batch Update AC Test entry</div>
          </b-col>
        </b-row>
        <!-- Continuity | Cable type & size | Breaker rating & setting | Phase rotation -->
        <b-row>
          <b-col class="mb-2" md="12" lg="4" xl="4">
            <label for="" class="text-white">Continuity </label>&nbsp;&nbsp;&nbsp;
            <toggle-button class="mr-2" v-model="oModel.acTest_update.continuity" :labels="oField.toggle_pass" :color="oField.toggle_color" :width="80" sync/>
          </b-col>
          <b-col class="mb-2" md="12" lg="4" xl="4">
            <label for="" class="text-white">Circuit From</label>
            <b-form-input placeholder="" v-model="oModel.acTest_update.ac_from"></b-form-input>
          </b-col>
          <b-col class="mb-2" md="12" lg="4" xl="4">
            <label for="" class="text-white">Circuit To</label>
            <b-form-input placeholder="" v-model="oModel.acTest_update.ac_to"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mb-2" md="12" lg="4" xl="4">
            <label for="" class="text-white">Cable type & size</label>
            <b-form-input placeholder="" v-model="oModel.acTest_update.cable_type_and_size"></b-form-input>
          </b-col>
          <b-col class="mb-2" md="12" lg="4" xl="4">
            <label for="" class="text-white">Breaker rating & setting</label>
            <b-form-input placeholder="" v-model="oModel.acTest_update.breaker_rating_and_setting"></b-form-input>
          </b-col>
          <b-col class="mb-2" md="12" lg="4" xl="4">
            <label for="" class="text-white">Phase rotation</label>
            <b-form-input placeholder="" v-model="oModel.acTest_update.phase_rotation"></b-form-input>
          </b-col>
        </b-row>
        <!-- Phase to Earth (MΏ) -->
        <hr class="hr" />
        <b-row class="modal-row-category">
          <b-col>
            <div class="text-white h3">Phase to Earth (MΏ)</div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mb-2" md="12" lg="3" xl="3">
            <label for="" class="text-white">L1-E</label>
            <b-form-input type="number" placeholder="" v-model="oModel.acTest_update.phase_to_earth_1"></b-form-input>
          </b-col>
          <b-col class="mb-2" md="12" lg="3" xl="3">
            <label for="" class="text-white">L2-E</label>
            <b-form-input type="number" placeholder="" v-model="oModel.acTest_update.phase_to_earth_2"></b-form-input>
          </b-col>
          <b-col class="mb-2" md="12" lg="3" xl="3">
            <label for="" class="text-white">L3-E</label>
            <b-form-input type="number" placeholder="" v-model="oModel.acTest_update.phase_to_earth_3"></b-form-input>
          </b-col>
          <b-col class="mb-2" md="12" lg="3" xl="3">
            <label for="" class="text-white">N-E</label>
            <b-form-input type="number" placeholder="" v-model="oModel.acTest_update.phase_to_earth_4"></b-form-input>
          </b-col>
        </b-row>
        <!-- Phase to Neutral (MΏ) -->
        <hr class="hr" />
        <b-row class="modal-row-category">
          <b-col>
            <div class="text-white h3">Phase to Neutral (MΏ)</div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mb-2" md="12" lg="4" xl="4">
            <label for="" class="text-white">L1-N</label>
            <b-form-input type="number" placeholder="" v-model="oModel.acTest_update.phase_to_neutral_1"></b-form-input>
          </b-col>
          <b-col class="mb-2" md="12" lg="4" xl="4">
            <label for="" class="text-white">L2-N</label>
            <b-form-input type="number" placeholder="" v-model="oModel.acTest_update.phase_to_neutral_2"></b-form-input>
          </b-col>
          <b-col class="mb-2" md="12" lg="4" xl="4">
            <label for="" class="text-white">L3-N</label>
            <b-form-input type="number" placeholder="" v-model="oModel.acTest_update.phase_to_neutral_3"></b-form-input>
          </b-col>
        </b-row>
        <!-- Phase to Phase (MΏ) -->
        <hr class="hr" />
        <b-row class="modal-row-category">
          <b-col>
            <div class="text-white h3">Phase to Phase (MΏ)</div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mb-2" md="12" lg="4" xl="4">
            <label for="" class="text-white">L1-L2</label>
            <b-form-input type="number" placeholder="" v-model="oModel.acTest_update.phase_to_phase_1"></b-form-input>
          </b-col>
          <b-col class="mb-2" md="12" lg="4" xl="4">
            <label for="" class="text-white">L1-L3</label>
            <b-form-input type="number" placeholder="" v-model="oModel.acTest_update.phase_to_phase_2"></b-form-input>
          </b-col>
          <b-col class="mb-2" md="12" lg="4" xl="4">
            <label for="" class="text-white">L2-L3</label>
            <b-form-input type="number" placeholder="" v-model="oModel.acTest_update.phase_to_phase_3"></b-form-input>
          </b-col>
        </b-row>
        <!-- Continuity -->
        <!-- <b-row class="mb-3" style="padding-top: 10px;">
          <b-col>
            <label for="" class="text-white">Continuity</label>
            <toggle-button class="mr-2" v-model="oModel.continuity" />
          </b-col>
          <b-col>
            
          </b-col>
        </b-row> -->

        <!-- buttons -->
        <b-row style="padding-top: 20px;">
          <b-col class="text-right">
            <base-button @click="modal_close('modal-ac-test-update-entry')" type="danger" outline>Cancel</base-button>
            <base-button @click="batch_process_update_ac_test_entry()" type="primary">Save</base-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

  </div>
</template>


<script>
import { LoginURL, clientId, clientSecret, apiDomain, getHeader, getcurrentDate } from "@/assets/js/config.js";
import ErrorFunctionMixin from "@/assets/js/errorFunctionMix.js";
import CustomLibHelper from "@/assets/js/customLibHelper.js";
import axios from "axios";

import { AgGridVue } from "@ag-grid-community/vue";
import HeaderGroupComponent from './HeaderGroupComponent.vue';
import '@ag-grid-enterprise/core';
import { ToggleButton } from 'vue-js-toggle-button'

import { isEmpty } from "lodash";

export default {
  props: ['shareData', 'acData'],
  mixins: [ErrorFunctionMixin, CustomLibHelper],
  components: {
    'ag-grid-vue': AgGridVue,
    HeaderGroupComponent,
    ToggleButton,
  },
  data() {
    return {
      oDev: {
        debug: false,
      },
      oField: {
        ac_test_id: null,
        dd_continuity: [
          {key: '0', value: 'Not Pass'},
          {key: '1', value: 'Pass'},
        ],
        toggle_color: {checked: '#75C791', unchecked: '#Cf3140', disabled: '#CCCCCC'},
        toggle_pass: {checked: 'Pass', unchecked: 'Not Pass'},  
      },
      columnDefs: [
        {
          headerName: '', minWidth: 60, width: 60, headerCheckboxSelection: true, checkboxSelection: true, sortable: false,
          headerClass: '', pinned: true, suppressHeaderMenuButton: true,
          cellClass: ''
        },
        {
          headerName: 'Circuit',
          headerGroupComponent: 'HeaderGroupComponent',
          headerClass: 'ag-center-content',
          children: [
            {
              headerName: "From",
              headerClass: 'ag-center-content',
              field: "ac_from",
              width: 300,
              cellRenderer: (params) => (params.value != '-to be update-') ? params.value.toString() : '',
            },
            {
              headerName: "To",
              headerClass: 'ag-center-content',
              field: "ac_to",
              width: 300,
              cellRenderer: (params) => (params.value != '-to be update-') ? params.value.toString() : '',
            },
          ]
        },
        {
          headerName: 'Cable \ntype & size',
          headerClass: 'ag-center-content',
          field: "cable_type_and_size",
          width: 250,
          cellRenderer: (params) => (params.value != '-to be update-') ? params.value.toString() : '',
          suppressHeaderMenuButton: true,
          type: 'rightAligned',
          // editable: true,
        },
        {
          headerName: 'Breaker \nrating & setting',
          headerClass: 'ag-center-content',
          field: "breaker_rating_and_setting",
          width: 250,
          cellRenderer: (params) => (params.value != '-to be update-') ? params.value.toString() : '',
          suppressHeaderMenuButton: true,
          type: 'rightAligned',
          // editable: true,
        },
        {
          headerName: 'Phase Rotation',
          headerClass: 'ag-center-content',
          field: "phase_rotation",
          width: 150,
          cellRenderer: (params) => (params.value != '-to be update-') ? params.value.toString() : '',
          suppressHeaderMenuButton: true,
          // editable: true,
        },
        {
          headerName: 'Phase to Earth (MΏ)',
          headerGroupComponent: 'HeaderGroupComponent',
          headerClass: 'ag-phase-to-earth',
          children: [
            {
              headerName: "L1-E",
              headerClass: 'ag-phase-to-earth',
              field: "phase_to_earth_1",
              width: 30,
              cellRenderer: (params) => params.value ? params.value.toString() : '',
            },
            {
              headerName: "L2-E",
              headerClass: 'ag-phase-to-earth',
              field: "phase_to_earth_2",
              width: 30,
              cellRenderer: (params) => params.value ? params.value.toString() : '',
            },
            {
              headerName: "L3-E",
              headerClass: 'ag-phase-to-earth',
              field: "phase_to_earth_3",
              width: 30,
              cellRenderer: (params) => params.value ? params.value.toString() : '',
            },
            {
              headerName: "N-E",
              headerClass: 'ag-phase-to-earth',
              field: "phase_to_earth_4",
              width: 30,
              cellRenderer: (params) => params.value ? params.value.toString() : '',
            },
          ]
        },
        {
          headerName: 'Phase to neutral (MΏ)',
          headerGroupComponent: 'HeaderGroupComponent',
          headerClass: 'ag-phase-to-neutral',
          children: [
            {
              headerName: "L1-N",
              headerClass: 'ag-phase-to-neutral',
              field: "phase_to_neutral_1",
              width: 50,
              cellRenderer: (params) => params.value ? params.value.toString() : '',
            },
            {
              headerName: "L2-N",
              headerClass: 'ag-phase-to-neutral',
              field: "phase_to_neutral_2",
              width: 50,
              cellRenderer: (params) => params.value ? params.value.toString() : '',
            },
            {
              headerName: "L3-N",
              headerClass: 'ag-phase-to-neutral',
              field: "phase_to_neutral_3",
              width: 50,
              cellRenderer: (params) => params.value ? params.value.toString() : '',
            },
          ]
        },
        {
          headerName: 'Phase to phase (MΏ)',
          headerGroupComponent: 'HeaderGroupComponent',
          headerClass: 'ag-phase-to-phase',
          children: [
            {
              headerName: "L1-L2",
              headerClass: 'ag-phase-to-phase',
              field: "phase_to_phase_1",
              width: 50,
              cellRenderer: (params) => params.value ? params.value.toString() : '',
            },
            {
              headerName: "L1-L3",
              headerClass: 'ag-phase-to-phase',
              field: "phase_to_phase_2",
              width: 50,
              cellRenderer: (params) => params.value ? params.value.toString() : '',
            },
            {
              headerName: "L2-L3",
              headerClass: 'ag-phase-to-phase',
              field: "phase_to_phase_3",
              width: 50,
              cellRenderer: (params) => params.value ? params.value.toString() : '',
            },
          ]
        },
        {
          headerName: 'Continuity',
          headerClass: '',
          field: "continuity",
          width: 100,
          cellRenderer: (params) => (params.value == 0) ? 'Fail' : 'Pass',
          suppressHeaderMenuButton: true,
          // editable: true,
        },
      ],
      gridApi: null,
      rowData: null,
      defaultColDef: {
        flex: 1,
        minWidth: 100,
      },
      oModel: {
        ac_test:{
          no_of_inverter: 0,
          ac_sub_test: []
        },
        ac_sub_template: {
          ac_from: '-to be update-',
          ac_to: '-to be update-',
          cable_type_and_size: '-to be update-',
          breaker_rating_and_setting: '-to be update-',
          phase_rotation: '-to be update-',
          phase_to_earth_1: 0,
          phase_to_earth_2: 0,
          phase_to_earth_3: 0,
          phase_to_earth_4: 0,
          phase_to_neutral_1: 0,
          phase_to_neutral_2: 0,
          phase_to_neutral_3: 0,
          phase_to_phase_1: 0,
          phase_to_phase_2: 0,
          phase_to_phase_3: 0,
          continuity: 0
        }, 
        acTest_new: null,
        acTest_update: {
          ac_from: '',
          ac_to: '',
          cable_type_and_size: '',
          breaker_rating_and_setting: '',
          phase_rotation: '',
          phase_to_earth_1: '',
          phase_to_earth_2: '',
          phase_to_earth_3: '',
          phase_to_earth_4: '',
          phase_to_neutral_1: '',
          phase_to_neutral_2: '',
          phase_to_neutral_3: '',
          phase_to_phase_1: '',
          phase_to_phase_2: '',
          phase_to_phase_3: '',
          continuity: false,
        },
      },
      //_ unused
      gridOptions_ORI: {
        columnDefs: [
          {
            field: 'circuit_from',
            minWidth: 150,
          },
          {
            field: 'circuit_to',
            minWidth: 150,
          },
          {
            field: 'cable_type_size',
            maxWidth: 90,
          },
          { field: 'breaker_rating_setting' },
          { field: 'phase_rotation' },
          { field: 'phase_to_earth_L1E' },
          { field: 'phase_to_earth_L2E' },
          { field: 'phase_to_earth_L3E' },
          { field: 'phase_to_earth_NE' },
          { field: 'phase_to_neutral_L1N' },
          { field: 'phase_to_neutral_L2N' },
          { field: 'phase_to_neutral_L3N' },
          { field: 'phase_to_phase_L1L2' },
          { field: 'phase_to_phase_L1L3' },
          { field: 'phase_to_phase_L2L3' },
          { field: 'continuity' },
        ]
      },
      autoSizeStrategy: {
        type: 'fitCellContents',
      },
      themeClass: 'ag-theme-quartz',
    }
  },
  computed: {
    is_editable() {
      return this.shareData.is_epc && this.shareData.status_tnc != 'APPROVED'
    }
  },
  methods: {
    onGridReady(params) {
      this.devMsg(this.oDev.debug, 'onGridReady - ac test', 'gs')
      // this.gridApi.value = params.api;

      this.gridApi = params.api;
      this.gridApi.sizeColumnsToFit();

      // fetch('https://www.ag-grid.com/example-assets/small-olympic-winners.json')
      //   .then((response) => response.json())
      //   .then(function (data) {
      //     params.api.updateGridOptions({ rowData: data });
      //   });

      params.api.updateGridOptions({ rowData: this.acData });

      if ( this.acData.length > 0 ) {
        this.oField.ac_test_id = this.acData[0].qaqc_ac_test_id
      }

      this.devMsg(this.oDev.debug, '', 'ge')
    },
    // onSelectionChanged() {
    //   // const selectedData = this.gridApi.value.getSelectedRows();
    //   const selectedData = this.gridApi.getSelectedRows();
    //   console.log('Selection Changed', selectedData);
    // },
    modal_show(whichModal) {
      //_ validation for certain modal before proceeding
      let bShowModal = true;

      //_ reset fields
      this.reset_ac_test_new_modal();

      if (whichModal == 'modal-ac-test-update-entry') {
        this.reset_ac_sub_test_modal_fields();
        let selectedData = this.gridApi.getSelectedRows();
        if (isEmpty(selectedData)) {
          this.redErrorNotify("<b>Please select AC Test entry.</b>");
          bShowModal = false;
        }
      }

      (bShowModal) ? this.$refs[whichModal].show() : '';
    },
    modal_close(whichModal) {
      this.$refs[whichModal].hide();
    },
    reset_ac_test_new_modal() {
      this.oModel.acTest_new = null;
    },
    reset_ac_sub_test_modal_fields() {
      this.oModel.acTest_update = {
        ac_from: '',
        ac_to: '',
        cable_type_and_size: '',
        breaker_rating_and_setting: '',
        phase_rotation: '',
        phase_to_earth_1: '',
        phase_to_earth_2: '',
        phase_to_earth_3: '',
        phase_to_earth_4: '',
        phase_to_neutral_1: '',
        phase_to_neutral_2: '',
        phase_to_neutral_3: '',
        phase_to_phase_1: '',
        phase_to_phase_2: '',
        phase_to_phase_3: '',
        continuity: false,
      };
    },


    batch_process_add_ac_test_entry() {
      /**
       * check is ac_test_id exist ? if yes then update
       * but if not, then create new entry
       * loop through how many ac test entry that the user entered, push the template data, so we're creating new blank data based on the template
       */
      this.devMsg(this.oDev.debug, 'batch_process_add_ac_test_entry', 'gs')
      let bProceed = false
      if ( this.oModel.acTest_new === null || this.oModel.acTest_new < 1 ) {
        this.redErrorNotify("<b>Please input how many entry going to be create.</b>");
      } else {
        bProceed = true;
      }

      if ( bProceed ) {
        this.$refs['modal-loading-in-progress'].show();
        
        this.devMsg(this.oDev.debug, 'param id: ' + this.$route.params.id)

        this.devMsg(this.oDev.debug, 'this.acData')
        this.devMsg(this.oDev.debug, this.acData)

        let api_url = apiDomain + 'qaqc/create_qaqc_ac_test/' + this.$route.params.id;

        //_ get the available data
        if ( this.oField.ac_test_id != null ) {
          this.devMsg(this.oDev.debug, 'masuk sini ga seh')

          api_url = apiDomain + 'qaqc/update_qaqc_ac_test/' + this.$route.params.id;

          this.oModel.ac_test.id = this.oField.ac_test_id
          this.oModel.ac_test.ac_sub_test = this.acData;
        }

        //_ add new data 
        for (let i = 0; i < this.oModel.acTest_new; i++) {
          this.devMsg(this.oDev.debug, i)
          this.oModel.ac_test.ac_sub_test.push( this.oModel.ac_sub_template );
          // this.acData.push( this.oModel.ac_sub_template );
        }

        this.devMsg(this.oDev.debug, 'this.oModel.ac_test')
        this.devMsg(this.oDev.debug, this.oModel.ac_test)

        axios
        .post(api_url, this.oModel.ac_test, { headers: getHeader() })
        .then((response) => {
          if (response.status === 200) {
            this.msg_notify_ok('<b>AC Test Entry Successfully Created.</b>');
          }
        })
        .catch((error) => {
          if (error.response) {
            // Handle error with response
            this.errorFunction(error, "Batch create AC Test Entry");
          } else {
            // Handle error without response
            this.msg_notify_sembcorp();
          }
        })
        .finally(() => {
          // this.gridApi.updateGridOptions({ rowData:  this.oModel.ac_test.ac_sub_test });
          // this.gridApi.refreshCells()
          this.$refs['modal-loading-in-progress'].hide();
          this.modal_close('modal-ac-test-generate-entry')
          // this.$router.push({ path: "/QAQC/TNC/edit/" + this.$route.params.id, });

          //_ need to reload the page
          // if ( this.oField.ac_test_id === null ) {
          //   this.$router.go(0);
          // }

          this.$router.go(0);
        });

      }   
      
      this.devMsg(this.oDev.debug, '', 'ge')
    },
    batch_process_update_ac_test_entry() {
      /**
       * basically get all the selected data (selectedData)
       * then empty field from the modal will not be update into the selected data (selectedData)
       * so remove all empty field in the modal
       * then apply populated modal fields into all the selected data (selectedData)
       */
      this.devMsg(this.oDev.debug, 'batch_process_update_ac_test_entry', 'gs')

      // let selectedData = this.gridApi.value.getSelectedRows();
      let selectedData = this.gridApi.getSelectedRows();
      let bProcess = false;

      if (isEmpty(selectedData)) {
        // alert('data kosong')
        this.msg_notify_ok('Please select entry data to be update.');
      } else {
        // console.log(selectedData[0].id);
        // alert(`Selected Data:\n${JSON.stringify(selectedData)}`);

        bProcess = true;
      }

      let new_keys;
      let new_obj = {};
      if ( bProcess ) {
        this.$refs['modal-loading-in-progress'].show();

        this.devMsg(this.oDev.debug, this.oModel.acTest_update)

        //_ get the ui fields and then remove that is not populated
        let old_obj = this.oModel.acTest_update
        let removeValue = ''
        new_keys = Object.keys(old_obj).filter(this_entry => old_obj[this_entry] !== removeValue);
        new_keys.forEach(key => new_obj[key] = old_obj[key]);

        // this.devMsg(this.oDev.debug, 'new_keys');
        // this.devMsg(this.oDev.debug, new_keys);
        // this.devMsg(this.oDev.debug, 'new_obj');
        // this.devMsg(this.oDev.debug, new_obj);

        // this.devMsg(this.oDev.debug, new_obj.cable_type_and_size)

        // this.devMsg(this.oDev.debug, 'test1:')
        // if ( new_obj.hasOwnProperty('cable_type_and_size') ) console.log(new_obj.cable_type_and_size);
        // this.devMsg(this.oDev.debug, 'test2:')
        // if ( new_obj.hasOwnProperty('phase_rotation') ) console.log(new_obj.phase_rotation);
        // this.devMsg(this.oDev.debug, 'end test')

        //_ applying the filled up UI field into the selectedData
        selectedData.forEach( (entry => {
          this.devMsg(this.oDev.debug, '>>> populating data')
          // if ( new_obj.hasOwnProperty('cable_type_and_size') ) console.log(new_obj.cable_type_and_size);
          if ( new_obj.ac_from !== undefined ) entry.ac_from = new_obj.ac_from;
          if ( new_obj.ac_to !== undefined ) entry.ac_to = new_obj.ac_to;
          if ( new_obj.cable_type_and_size !== undefined ) entry.cable_type_and_size = new_obj.cable_type_and_size;
          if ( new_obj.breaker_rating_and_setting !== undefined ) entry.breaker_rating_and_setting = new_obj.breaker_rating_and_setting;
          if ( new_obj.phase_rotation !== undefined ) entry.phase_rotation = new_obj.phase_rotation;
          if ( new_obj.phase_to_earth_1 !== undefined ) entry.phase_to_earth_1 = new_obj.phase_to_earth_1;
          if ( new_obj.phase_to_earth_2 !== undefined ) entry.phase_to_earth_2 = new_obj.phase_to_earth_2;
          if ( new_obj.phase_to_earth_3 !== undefined ) entry.phase_to_earth_3 = new_obj.phase_to_earth_3;
          if ( new_obj.phase_to_earth_4 !== undefined ) entry.phase_to_earth_4 = new_obj.phase_to_earth_4;
          if ( new_obj.phase_to_neutral_1 !== undefined ) entry.phase_to_neutral_1 = new_obj.phase_to_neutral_1;
          if ( new_obj.phase_to_neutral_2 !== undefined ) entry.phase_to_neutral_2 = new_obj.phase_to_neutral_2;
          if ( new_obj.phase_to_neutral_3 !== undefined ) entry.phase_to_neutral_3 = new_obj.phase_to_neutral_3;
          if ( new_obj.phase_to_phase_1 !== undefined ) entry.phase_to_phase_1 = new_obj.phase_to_phase_1;
          if ( new_obj.phase_to_phase_2 !== undefined ) entry.phase_to_phase_2 = new_obj.phase_to_phase_2;
          if ( new_obj.phase_to_phase_3 !== undefined ) entry.phase_to_phase_3 = new_obj.phase_to_phase_3;
          if ( new_obj.continuity ) {
            entry.continuity = 1
          } else {
            entry.continuity = 0
          }
          
        }))
        this.devMsg(this.oDev.debug, 'selectedData')
        this.devMsg(this.oDev.debug, selectedData);

        this.oModel.ac_test.id = this.oField.ac_test_id
        this.oModel.ac_test.ac_sub_test = selectedData;

        this.devMsg(this.oDev.debug, 'this.oModel.ac_test')
        this.devMsg(this.oDev.debug, this.oModel.ac_test)
        
        let api_url = apiDomain + 'qaqc/update_qaqc_ac_test/' + this.$route.params.id;
        axios
        .post(api_url, this.oModel.ac_test, { headers: getHeader() })
        .then((response) => {
          if (response.status === 200) {
            this.msg_notify_ok('<b>AC Test Entry Successfully Updated.</b>');
          }
        })
        .catch((error) => {
          if (error.response) {
            // Handle error with response
            this.errorFunction(error, "Batch Update AC Test Entry");
          } else {
            // Handle error without response
            this.msg_notify_sembcorp();
          }
        })
        .finally(() => {
          this.gridApi.refreshCells()
          this.$refs['modal-loading-in-progress'].hide();
          this.modal_close('modal-ac-test-update-entry')          
        });        
      }

      this.devMsg(this.oDev.debug, '', 'ge')
      // return selectedData;
    },

    //_ libs helper specific this module only


    // onGridReady() {
    //   //console.log('selectionChanged');
    // },
  },
  created() {
  },
  mounted() {
  },
  beforeMount() {
  }
}
</script>


<!-- ag-grid related -->
<style>
.ag-phase-to-earth {
  background-color: #fde9d9;
  justify-content: center;
}

.ag-phase-to-neutral {
  background-color: #dce6f1;
  justify-content: center;
}

.ag-phase-to-phase {
  background-color: #f2dcdb;
  justify-content: center;
}

.ag-center-content {
  justify-content: center;
}

.ag-header-cell-label .ag-header-cell-text {
  white-space: pre-wrap !important;
}

.column-2 {
  background-color: #c9daf8;
  /* light blue */
}

.column-3 {
  background-color: #d9ead3;
  /* light green */
}

.ag-root-wrapper-body.ag-layout-normal {
  height: 700px
}

.ag-cell {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

label {
  font-weight: normal !important;
}

.bg-default-dashboard {
  background-color: #082A2F;
  padding: 0;
  margin: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.div-percent-bar {
  display: inline-block;
  height: 100%;
  position: relative;
  z-index: 0;
}

.div-percent-value {
  position: absolute;
  padding-left: 4px;
  font-weight: bold;
  font-size: 13px;
  z-index: 100;
}

.div-outer-div {
  display: inline-block;
  height: 100%;
  width: 100%;
}

.ag-menu {
  z-index: 200;
}

.toolbar button {
  margin-left: 5px;
  margin-right: 5px;
  padding: 2px;
}
</style>

<!-- form element -->
<style scoped>
/deep/ hr{
  background-color: white;
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

/deep/ .form-control {
  background-color: #2C545A;
  border-color: #2C545A;
  color: white;

  &:focus {
    background-color: #2C545A;
    border-color: #2C545A;
    /* color: white; */
  }

  &::placeholder {
    color: rgb(163, 163, 163);
  }
}

/deep/ .form-control {
  &:focus {
    &::placeholder {
      color: rgb(163, 163, 163);
    }
  }
}

/deep/ .input-group-text {
  background-color: #2C545A;
  ;
  color: white;

  &:focus {
    background-color: #2C545A;
    ;
    border-color: #1D4147;
    color: white;
  }
}

/deep/ input::-webkit-input-placeholder {
  color: #fff;
}

/deep/ input::-moz-input-placeholder {
  color: #fff;
}

/deep/ input::-ms-input-placeholder {
  color: #fff;
}

/deep/ .el-input .el-input__inner {
  background-color: #2C545A;
  color: #fff;
  border: 0px;
  border-radius: 10px;
  padding-top: 3px;
  padding-bottom: 2px;

  /* &::placeholder {
    color: white;
  } */
}

/deep/ .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #23504e;
}

/deep/ .el-select-dropdown {
  background-color: #306b74;
  margin: 0px;
}

/deep/ .el-select-dropdown__item {
  color: white;
  background-color: #183034;

  ::hover {
    background-color: #2C545A
  }

}

/deep/ .el-select {
  .el-input .el-input__inner {
    &::placeholder {
      color: white;
    }
  }

}

/deep/ .el-select__input {
  color: white;
  background-color: #2C545A;
}

/deep/ .el-select__input.hover,
.el-select__input:hover {
  background-color: #23504e;
}
</style>

<!-- modal -->
<style scoped>
/deep/ .modal-content {
  background-color: #306b74 !important;
}

/deep/ .modal-body {
  background-color: #306b74 !important;
}

/deep/ .modal-row-header {
  padding-bottom: 20px;
}

/deep/ .modal-row-category {
  padding-top: 5px;
  padding-bottom: 0px;
}
</style>

<!-- dropdown action menu -->
<style scoped>
/deep/ .btn-dark,
.btn-dark:hover {
  color: #fff;
  background-color: #2c545a;
  border-color: #2c545a;
}

/deep/ .dropdown-menu {
  background-color: #23444a !important;
  border: 1px solid #ffffff;
}

/deep/ .dropdown-item {
  &:hover {
    background-color: #3a656b !important;
    color: #ffffff;
  }

  span {
    padding-left: 8px;
    vertical-align: super;
  }
}
</style>